export enum SourceType {
  CONTACT = "CONTACT",
  PRODUCT = "PRODUCT",
}

export enum ImportationDetailsStatus {
  CREATED = "CREATED",
  UPDATED = "UPDATED",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

export interface IImportationDetailsInput {
  importProcessId: number;
  sourceType: SourceType;
  code: string;
  name: string;
  status: ImportationDetailsStatus;
  message: string | null;
  integrationDate: Date;
}

export default interface IImportationDetails extends IImportationDetailsInput {
  id: number;
  rowDate: string;
}
